import { type UseQueryResult, useQuery } from '@tanstack/react-query';

import api from '@/axios';
import { GET_PRODUCTION_DECLARATION_MATERIALS_COMPLETENESS_KEY } from '@/keys';
import type { ProductionDeclarationMaterialCompleteness } from '@/types/core/purchase-order/production-declaration-material-completeness';

async function getProductionDeclarationMaterialsCompleteness(
  productionDeclarationId: string,
  options?: { token?: string },
): Promise<ProductionDeclarationMaterialCompleteness[]> {
  const response = await api.get<ProductionDeclarationMaterialCompleteness[]>(
    `/production-declarations/${productionDeclarationId}/materials/completeness`,
    {
      params: options?.token ? { token: options.token } : undefined,
    },
  );

  return response.data;
}

export function useGetProductionDeclarationMaterialsCompleteness(
  productionDeclarationId: string,
  token: string | undefined,
): UseQueryResult<ProductionDeclarationMaterialCompleteness[], Error> {
  return useQuery({
    queryKey: [
      ...GET_PRODUCTION_DECLARATION_MATERIALS_COMPLETENESS_KEY,
      productionDeclarationId,
      token ?? '',
    ],
    queryFn: async () =>
      await getProductionDeclarationMaterialsCompleteness(
        productionDeclarationId,
        { token },
      ),
    enabled: Boolean(productionDeclarationId),
  });
}
